module.exports = __webpack_public_path__ + "img/WSIS-thumbnail-1024x592-1-thegem-portfolio-masonry-img11.66c7becf.png";